import React, { Component } from "react";
import { can, canImport, isSelfEmployedMe } from '../permissions/access';
import { markFirstTask } from '../onboarding/firstTaskRegistry';
import { Dropdown } from "react-bootstrap";
import { openOnboardingLayer } from "../onboarding/ImportJobContext";
import { ONBOARDING_ENABLED } from "../onboarding/flags";
import moment from 'moment';
import TopHeader from "../template/TopHeader";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { hairdresserActions, userActions } from "../../_actions";
import { hairdresserService } from "../../_services";
import SlidePanel from "../shared/SlidePanel";
import { clientService } from "../../_services/client.service";
import { clientSyncService } from "../../_services/clientSync.service";
import Lottie from "react-lottie";
import animationData from "../../assets/animation-data/loader.json";

import ClientsTopNav from "./ClientsTopNav";
import ClientFiltersPopup from "./ClientFiltersPopup";
import ClientDetailPanel from "./ClientDetailPanel";
import MergeClientsPanel from "./MergeClientsPanel";
import DuplicatesReviewPanel from "./duplicates/DuplicatesReviewPanel";
import MergeResultToast from "./duplicates/MergeResultToast";
import { clientDuplicatesService } from "../../_services/clientDuplicates.service";
import { refusalCopy } from "./duplicates/duplicateCopy";
import AddClientPanel from "./AddClientPanel";
import { RxCross2 } from "react-icons/rx";
import toast from '../shared/Toast';
import ListContextMenu from '../shared/ListContextMenu';
import { sitesService, siteColour } from '../../_services/sites.service';
import { loadSites } from '../multiLocation/useSites';
import "./Clients.css";
import "./ClientsToolbar.css";
import "./MergeMode.css";
import "../staff/Staff.css";
const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: animationData,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

function debounce(func, delay) {
  let timer;
  return function() {
    const context = this;
    const args = arguments;
    clearTimeout(timer);
    timer = setTimeout(() => func.apply(context, args), delay);
  };
}


var date = new Date();
class Clients extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchKey: "",
      startDate: null,
      endDate: null,
      myData: [{ label: "All Staff", value: "0" }],
      isSelectopen: false,
      selectedOption: [],
      selectedValue: [],
      hairdresserLodingStatus:true,
      staffData: [],
      selectedStaffName: "",
      hairdresserClient: [],
      selectedHairdresserIds:[],
      isSalonOwner:0,
      selectedHairdressers:[],
      staffList:[],
      filterPopup: false,
      filters: {
        teamMembers: [],
        teamMemberNames: null,
        startDate: null,
        endDate: null,
        minSales: null,
        maxSales: null,
        searchQuery: ""
      },
      searchCrossIcon: false,
      sortField: 'name',
      sortOrder: 'asc',
      currentPage: 1,
      hasMore: true,
      isLoadingMore: false,
      isLoading: true,
      pagination: null,
      // Merge mode states
      mergeMode: false,
      selectedClients: [],
      // Merge mode: the server's verdict on the two picked, before the panel
      // opens ({ pairKey, code } once known; code null = can merge).
      mergeCheck: null,
      // Bulk marketing-permissions mode: select clients, then opt them in or
      // out of email/SMS marketing in one action
      consentMode: false,
      consentModalOpen: false,
      consentApplying: false,
      consentProgress: 0,
      consentEmail: true,
      consentSms: true,
      consentValue: true,
      consentConfirmed: false,
      consentSelectingAll: false,
      consentAllSelected: false,
      clientDetailPanelId: null,
      clientDetailAction: null,
      showAddClientPanel: false,
      contextMenu: null,
      viewportWidth: (typeof window !== 'undefined' && window.innerWidth) || 1200,
      showMoreSheet: false,
    };
    this.selectClient = this.selectClient.bind(this);
    this.searchClient = this.searchClient.bind(this);
    this.checkReadOnly = this.checkReadOnly.bind(this);
    this.debouncedFunction = this.debouncedFunction.bind(this);
    this.debouncedSearch = debounce(this.debouncedFunction, 500);
    this.exportCSV = this.exportCSV.bind(this);
    this.filterClick = this.filterClick.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleApplyFilters = this.handleApplyFilters.bind(this);
    this.handleResetFilters = this.handleResetFilters.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.handleResetSearchChange = this.handleResetSearchChange.bind(this);
    this.handleSort = this.handleSort.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.loadMoreClients = this.loadMoreClients.bind(this);
  }

  handleScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const scrollHeight = document.documentElement.scrollHeight;
    const clientHeight = document.documentElement.clientHeight;
    
    // Load more when user scrolls to bottom (with 100px threshold)
    if (scrollTop + clientHeight >= scrollHeight - 100) {
      this.loadMoreClients();
    }
  }

  loadMoreClients() {
    const { isLoadingMore, hasMore, currentPage, filters, sortField, sortOrder } = this.state;
    
    // Don't load if already loading or no more data
    if (isLoadingMore || !hasMore) {
      return;
    }
    
    let hairdresserId = localStorage.getItem("userId");
    let selectedHairdresserIds = hairdresserId;
    if (filters.teamMembers && filters.teamMembers.length > 0) {
      selectedHairdresserIds = filters.teamMembers.map(tm => tm.value);
    }
    
    const nextPage = currentPage + 1;
    
    // Update currentPage BEFORE making the API call so componentDidUpdate knows to append
    this.setState({ isLoadingMore: true, currentPage: nextPage });
    
    let params = {
      searchKey: filters.searchQuery || "",
      hairdresserId: selectedHairdresserIds,
      empIds: Array.isArray(selectedHairdresserIds) ? selectedHairdresserIds : undefined,
      page: nextPage,
      // MUST match the initial/filter load's page size (the action defaults to
      // 20). Page 1 fetches 20 but this used 50 → skip = (page-1)*50 = 50 on
      // page 2, so rows 21-50 were never fetched (list jumped A-B → N-Z). The
      // backend computes skip as (page-1)*limit, so a consistent limit is
      // mandatory or pages overlap/gap.
      limit: 20,
      listType: 1,
      isDownload: 0,
      sortField: sortField,
      sortOrder: sortOrder
    };

    // Only include date filters if they are set
    if (filters.startDate) {
      params.startDate = filters.startDate;
    }
    if (filters.endDate) {
      params.endDate = filters.endDate;
    }
    
    // Only include sales filters if they are set
    if (filters.minSales !== null && filters.minSales !== undefined) {
      params.minSales = filters.minSales;
    }
    if (filters.maxSales !== null && filters.maxSales !== undefined) {
      params.maxSales = filters.maxSales;
    }
    
    this.props.dispatch(hairdresserActions.getHairdresserClient(params))
      .then(() => {
        this.setState({
          isLoadingMore: false
        });
      })
      .catch(() => {
        // Revert currentPage on error
        this.setState({ isLoadingMore: false, currentPage: currentPage });
      });
  }

  handleSort(field) {
    const { sortField, sortOrder } = this.state;
    let newSortOrder = 'asc';
    
    // If clicking the same field, toggle the order
    if (sortField === field) {
      newSortOrder = sortOrder === 'asc' ? 'desc' : 'asc';
    }
    
    this.setState({
      sortField: field,
      sortOrder: newSortOrder,
      isLoading: true
    }, () => {
      this.applyFiltersToData();
    });
  }

  filterClick() {
    this.setState(prev => ({ filterPopup: !prev.filterPopup }));
  }

  handleClose() {
    this.setState({ filterPopup: false });
  }

  handleApplyFilters(filters) {
    this.setState({ filters }, () => {
      this.applyFiltersToData();
    });
  }

  handleResetFilters(filterKey) {
    this.setState(prevState => ({
      filters: {
        ...prevState.filters,
        [filterKey]: filterKey === 'teamMembers' ? [] : null,
        ...(filterKey === 'teamMembers' && { teamMemberNames: null })
      }
    }), () => {
      this.applyFiltersToData();
    });
  }

  handleSearchChange(e) {
    const value = e.target.value;
    // Immediately clear client data when search changes to prevent stale data showing
    this.setState(prevState => ({
      searchKey: value,
      searchCrossIcon: value.length > 0,
      hairdresserClient: [], // Clear immediately to prevent stale data
      isLoading: true,
      filters: {
        ...prevState.filters,
        searchQuery: value
      }
    }), () => {
      this.debouncedSearch();
      this.searchOtherSites(value);
    });
  }

  // Multi-location (Shared → Clients "Also visits"/"Shared"): the same search
  // also asks the owner's other locations, listed under the table with the
  // location they're known at. Best-effort; never blocks this list.
  searchOtherSites(value) {
    const q = String(value || '').trim();
    if (this._otherSitesTimer) clearTimeout(this._otherSitesTimer);
    if (q.length < 2) { if (this.state.otherSiteClients && this.state.otherSiteClients.length) this.setState({ otherSiteClients: [] }); return; }
    this._otherSitesTimer = setTimeout(() => {
      loadSites(false).then((d) => {
        if (!d || !d.sites || d.sites.length < 2) return null;
        return sitesService.clientSearch(q, 10);
      }).then((r) => {
        if (String(this.state.searchKey || '').trim() !== q) return;
        this.setState({ otherSiteClients: (r && Array.isArray(r.results)) ? r.results : [] });
      }).catch(() => { /* ignore */ });
    }, 500);
  }

  handleResetSearchChange() {
    if (this._otherSitesTimer) clearTimeout(this._otherSitesTimer);
    this.setState(prevState => ({
      otherSiteClients: [],
      searchKey: "",
      searchCrossIcon: false,
      filters: {
        ...prevState.filters,
        searchQuery: ""
      }
    }), () => {
      this.debouncedSearch();
    });
  }

  applyFiltersToData() {
    const { filters } = this.state;
    let hairdresserId = localStorage.getItem("userId");
    
    // If multiple team members are selected, use their IDs
    let selectedHairdresserIds = hairdresserId;
    if (filters.teamMembers && filters.teamMembers.length > 0) {
      selectedHairdresserIds = filters.teamMembers.map(tm => tm.value);
    }
    
    // Clear saved state when applying new filters/search to prevent stale data
    this.props.dispatch(hairdresserActions.clearClientListState());
    
    // Reset to page 1 when applying filters - also reset isLoadingMore to ensure data is replaced not appended
    this.setState({
      currentPage: 1,
      hairdresserClient: [],
      hasMore: true,
      isLoading: true,
      isLoadingMore: false  // Important: reset this so componentDidUpdate replaces data instead of appending
    });
    
    let params = {
      searchKey: filters.searchQuery || "",
      hairdresserId: selectedHairdresserIds,
      empIds: Array.isArray(selectedHairdresserIds) ? selectedHairdresserIds : undefined,
      page: 1,
      listType: 1,
      isDownload: 0,
      sortField: this.state.sortField,
      sortOrder: this.state.sortOrder
    };

    // Only include date filters if they are set
    if (filters.startDate) {
      params.startDate = filters.startDate;
    }
    if (filters.endDate) {
      params.endDate = filters.endDate;
    }
    
    // Only include sales filters if they are set
    if (filters.minSales !== null && filters.minSales !== undefined) {
      params.minSales = filters.minSales;
    }
    if (filters.maxSales !== null && filters.maxSales !== undefined) {
      params.maxSales = filters.maxSales;
    }

    this.getHairdresserClient(params);
  }

  // Duplicates run on demand: the page only asks whether "Find duplicates"
  // is on for this viewer (no scan). The check itself runs when it's tapped,
  // so opening Clients never costs a big salon a 20K-client scan.
  loadDuplicates = () => {
    clientDuplicatesService.status()
      .then((on) => this.setState({ duplicatesAvailable: on }));
  };

  handleDuplicatesMerged = ({ batchIds, results }) => {
    // The panel closes itself (with its slide-out); just show the result.
    this.setState({ mergeResult: { batchIds, results, key: Date.now() } });
    this.applyFiltersToData();
    this.loadDuplicates();
  };

  componentDidMount() {
    this.loadDuplicates();
    clientSyncService.mergeStatus()
      .then((res) => {
        const d = res?.data?.responseData || res?.data?.data;
        this.setState({ salonMergeEnabled: d ? d.salonMergeEnabled === true : true });
      })
      // An API without the endpoint predates the pause: merging works there.
      .catch(() => this.setState({ salonMergeEnabled: true }));
    // Listen for universal search client open events
    this._searchOpenClient = (e) => {
      if (e.detail?.clientId) {
        this.setState({ clientDetailPanelId: e.detail.clientId });
      }
    };
    document.addEventListener('beu-open-client', this._searchOpenClient);

    // Live viewport width so mobile/desktop layout switches on resize/rotation
    this._onViewportResize = () => this.setState({ viewportWidth: window.innerWidth });
    window.addEventListener('resize', this._onViewportResize);

    // Deep-link: /clients/:id opens the detail panel for that client on load.
    if (this.props.match?.params?.id) {
      this.setState({ clientDetailPanelId: this.props.match.params.id });
    }

    if (this.props.location?.state?.openAddPanel) {
      this.setState({ showAddClientPanel: true });
      // Clear the state so refreshing doesn't re-open
      this.props.history.replace({ pathname: this.props.location.pathname, state: {} });
    }

    if (localStorage.getItem("accessToken")) {
      let hairdresserId = localStorage.getItem("userId");

      // Add scroll event listener for infinite scroll
      window.addEventListener('scroll', this.handleScroll);
      
      // Check if we have saved state from previous navigation
      const savedState = this.props.hairdresserClientListState;
      // Use saved client data from our state persistence, not from hairdresserClient reducer
      const savedClientData = savedState?.clientData;
      
      // Check if we're returning from a client detail page (using browser history)
      // We only restore state if coming back from client detail, not on fresh navigation
      const isReturningFromDetail = this.props.history?.action === 'POP' ||
                                     (this.props.location?.state?.fromClientDetail === true);
      
      // If we have saved state with client data AND we're returning from detail, restore the state
      if (savedState?.hasData && savedClientData && savedClientData.length > 0 && isReturningFromDetail) {
        // Restore the saved state including the accumulated client data
        this.setState({
          searchKey: savedState.searchKey || "",
          searchCrossIcon: (savedState.searchKey || "").length > 0,
          filters: savedState.filters || this.state.filters,
          sortField: savedState.sortField || 'name',
          sortOrder: savedState.sortOrder || 'asc',
          currentPage: savedState.currentPage || 1,
          hairdresserClient: savedClientData, // Restore accumulated client data from saved state
          hairdresserLodingStatus: false,
          isLoading: false
        }, () => {
          // Restore scroll position after render - use multiple attempts to ensure DOM is ready
          if (savedState.scrollPosition) {
            // First attempt after initial render
            requestAnimationFrame(() => {
              window.scrollTo(0, savedState.scrollPosition);
              // Second attempt after a short delay to ensure all content is rendered
              setTimeout(() => {
                window.scrollTo(0, savedState.scrollPosition);
              }, 200);
            });
          }
        });
        
        // Still fetch staff data
        this.getStaff();
      } else {
        // No saved state, fetch fresh data
        let params = {
          searchKey: this.state.searchKey,
          hairdresserId: hairdresserId,
          page: 1,
          listType: 1,
          isDownload: 0,
          sortField: this.state.sortField,
          sortOrder: this.state.sortOrder
        };
        this.getHairdresserClient(params);
        this.getStaff();
      }
    } else {
      this.props.history.push("/");
    }
  }

  // Note: componentWillUnmount is defined later in the file - state saving logic moved there

  getHairdresserClient(params) {
    var self = this;
    self.props.dispatch(hairdresserActions.getHairdresserClient(params)).then(res=>{
      self.setState({
        hairdresserLodingStatus:false,
        isLoading: false
      })
    }).catch(err=>{
      self.setState({
        hairdresserLodingStatus:false,
        isLoading: false
      })
      console.log(err);
    });
  }
 
  // this function have for staff dropdown
  getStaff() {
    var self = this;
    let hairdresserId = localStorage.getItem("userId");
    let staffParams = {
      searchKey: this.state.searchKey,
      hairdresserId: hairdresserId,
      page: 1,
      listType: 1,
    };

    self.props
      .dispatch(hairdresserActions.hairdresserStaffRota(staffParams))
      .then((res_staff) => {
       
        if (res_staff?.status === 200) {
          const data = res_staff?.data?.data?.rota;
          let loginUserId = localStorage.getItem('userId');
          
          if (data?.length > 0) {
            let staff_data = data.filter(
              (check_data) => check_data?.name !== undefined
            );
            let staffOptions = staff_data.map((emp) => {
              return { label: emp?.name, value: emp?._id };
            });

            let _staffII = staff_data.find(_staff=>_staff?._id===loginUserId); 
            if(_staffII?.hairdresserInfo?.isSalonOwner===1){
              this.setState({
                isSalonOwner: _staffII?.hairdresserInfo?.isSalonOwner,
              });
            }

            staffOptions.unshift({ label:'All Staff', value: '0' });          
            this.setState({
              staffData: staff_data,
              myData:staffOptions
            });
          }
        }
      });
  }

  selectClient(clientId, action = null) {
    this.setState({ clientDetailPanelId: clientId, clientDetailAction: action });
    if (clientId) markFirstTask('client');
    // Reflect the open panel in the URL so it's deep-linkable / shareable and
    // back closes it — matching the diary/booking pattern.
    if (clientId && this.props.match?.params?.id !== String(clientId)) {
      this.props.history.push('/clients/' + clientId);
      // Remember that WE added the history entry, so closing can pop it rather
      // than push a third one (see handleClientPanelClose).
      this._panelPushedHistory = true;
    }
  }

  handleClientContextMenu = (e, client) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({
      contextMenu: { clientId: client._id, clientName: client.name, x: e.clientX, y: e.clientY }
    });
  }

  handleContextMenuAction = (action) => {
    const { contextMenu } = this.state;
    if (!contextMenu) return;
    if (action === 'view') {
      this.selectClient(contextMenu.clientId);
    } else if (action === 'delete') {
      this.selectClient(contextMenu.clientId, 'delete');
    }
  }

  handleClientPanelClose = (didDelete) => {
    this.setState({ clientDetailPanelId: null });
    // Drop the client id from the URL when the panel closes.
    //
    // MUST POP, NOT PUSH. Pushing '/clients' left the stack as
    // /clients -> /clients/:id -> /clients, so the header back arrow went
    // BACK to /clients/:id and componentDidUpdate re-synced that id into
    // state — reopening the panel the user had just closed (mobile bug,
    // reported 2026-08-04). goBack() removes the entry we added; a
    // deep-linked visit (we never pushed) replaces instead, so back still
    // exits the page properly.
    if (this.props.match?.params?.id) {
      if (this._panelPushedHistory) {
        this._panelPushedHistory = false;
        this.props.history.goBack();
      } else {
        this.props.history.replace('/clients');
      }
    }
    if (didDelete) {
      this.applyFiltersToData();
    }
  }

  // The panel stays open after an inline edit and refetches its own detail,
  // but the list row behind it is served from cached state — so it showed the
  // old name until a full reload. Patch the matching row in place (keyed by
  // the client's user id) so the list reflects the edit immediately, without a
  // reload flash or losing scroll position.
  handleClientUpdated = (updated) => {
    if (!updated || !updated.userId) return;
    const uid = String(updated.userId);
    this.setState(prev => ({
      hairdresserClient: (prev.hairdresserClient || []).map(c =>
        (String(c._id) === uid || String(c.userId) === uid) ? { ...c, ...updated } : c
      )
    }));
  }

  checkEmail = (email) => {
    let emailArr = email.split("@");
    if (emailArr[1] === "beuapp.com") {
      return false;
    } else {
      return true;
    }
  };

  debouncedFunction() {
    // Apply filters which will trigger the API call with isLoading state
    this.applyFiltersToData();
   


//    console.log('dddddddd',);
  }

  searchClient(e) {
    let self = this;
       self.setState(
      {
        searchKey: e.target.value,
      },
      function () {
        this.debouncedSearch();
      }
    );
  }

  exportCSV(download=1) {
    var self = this;
    let { dispatch } = self.props;
    if (localStorage.getItem("accessToken")) {
      let hairdresserId =self?.state.selectedHairdresserIds?.length>0?self?.state.selectedHairdresserIds:[localStorage.getItem("userId")];
      let  params = {
          searchKey: this.state.searchKey,
          hairdresserId: hairdresserId,
          empIds: this.state.selectedValue,
          listType: 1,
          isDownload: download,
        };
      
      // Only include date filters if they are set
      if (this.state.filters.startDate) {
        params.startDate = this.state.filters.startDate;
      }
      if (this.state.filters.endDate) {
        params.endDate = this.state.filters.endDate;
      }

      // Use the new paginated API for all client list requests
      dispatch(hairdresserActions.getHairdresserClient(params)).then((res) => {
        if(params.isDownload===1){
          // Handle CSV download
          const { responseData } = res?.data;
          if(responseData?.file){
            window.open(responseData.file);
          }
        }
        // If not downloading, the data is already in Redux store via the action
      });
    }
  }

 compare = ( a, b ) => {
    if ( a.name < b.name ){
      return -1;
    }
    if ( a.name > b.name ){
      return 1;
    }
    return 0;
  }
  
 

  // Export: the owner, a self-employed stylist (their own book), or — with
  // roles on — anyone whose role has clients_export. Employed staff can't
  // export any more; the server refuses it (docs/permissions.md §6).
  canExportClients() {
    const hd = (this.props.user && this.props.user.userInfo && this.props.user.userInfo.hairdresser) || {};
    const owner = Number(hd.isSalonOwner) === 1;
    const se = Number(hd.employmentTypeId) === 2;
    return owner || se || can('clients_export');
  }

  // Roles & permissions (access audit 2026-10-02). Merging needs clients_all
  // (an SE may merge two of their own); removing someone else's client needs
  // clients_all — the server refuses otherwise. can() reads the server's
  // user.access, which gives unassigned staff their account type's default.
  canMergeClients() {
    // Salon merges are paused server-side until every merge moves everything
    // (BE GET /v2/user-merge/status); hidden until the answer is known.
    if (this.state.salonMergeEnabled !== true) return false;
    return can('clients_all') || isSelfEmployedMe();
  }

  canDeleteFromList() {
    return can('clients_all') || isSelfEmployedMe();
  }

  checkReadOnly() {
    if (
      this.props.user &&
      this.props.user.userInfo &&
      (this.props.user.userInfo.hairdresser.isSalonOwner === 1 ||
        this.props.user.userInfo.hairdresser.isSalonOwner === "1" ||
        this.props.user.userInfo.hairdresser.employmentTypeId === "1" ||
        this.props.user.userInfo.hairdresser.employmentTypeId === 1 ||
        this.props.user.userInfo.hairdresser.employmentTypeId === "2" ||
        this.props.user.userInfo.hairdresser.employmentTypeId === 2)
    ) {
      return true;
    } else {
      return false;
    }
  }

  dateFilter = (e, field) => {
    console.log(e, field);
    let self = this.state;
    this.setState(
      {
        [field]: e,
      },
      function () {
        this._getDataVal(this.state,1);
      }
    );
  };

  _getDataVal(val,updateClient=0) {
    var self = this;
    self.setState({ showLoader: true });
    if(updateClient===1){
      if(self.state.filters.startDate && self.state.filters.endDate ){
        let hairdresserId = localStorage.getItem("userId");
         let params = {
            searchKey: self.state.searchKey,
            hairdresserId: hairdresserId,
            empIds: self.state.selectedValue,
            listType: 1,
            isDownload: 0,
          };
          
          // Only include date filters if they are set
          if (self.state.filters.startDate) {
            params.startDate = self.state.filters.startDate;
          }
          if (self.state.filters.endDate) {
            params.endDate = self.state.filters.endDate;
          }

          this.exportCSV(0);
          console.log('exportCsvData1',0)
          }
    }
  }

  componentWillUnmount() {
    let self = this;
    window.removeEventListener('scroll', self.handleScroll);
    document.body.classList.remove('diary-temp');
    document.removeEventListener("mousedown", this.handleClickOutsideFilter);
    if (this._searchOpenClient) document.removeEventListener('beu-open-client', this._searchOpenClient);
    if (this._onViewportResize) window.removeEventListener('resize', this._onViewportResize);
    
    // Save current state before unmounting for state restoration when returning
    const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
    this.props.dispatch(hairdresserActions.saveClientListState({
      searchKey: this.state.searchKey,
      filters: this.state.filters,
      sortField: this.state.sortField,
      sortOrder: this.state.sortOrder,
      currentPage: this.state.currentPage,
      scrollPosition: scrollPosition,
      // Save the accumulated client data so we can restore it
      clientData: this.state.hairdresserClient
    }));
  }


  handleSelectChange = (value, event) => {
    let self = this;
    let hairdresserId = localStorage.getItem("userId");
    let params = {
      searchKey: '',
      hairdresserId:value?.length>1?hairdresserId:value?.length==1?value[0].value:hairdresserId,
      page: 1,
      listType: 1,
      isDownload: 0,
    };

    if (event.action === "select-option" && event.option.value == "0") {
      let _selected_staff = this.state.myData?.map((_selected) => {
        return _selected.value;
      });
      _selected_staff.splice(0, 1);

      console.log('check the all selected data',_selected_staff);

      this.setState({
        selectedStaffName: "All Staff Selected",
      });
     // params.empIds = _selected_staff;
      // this.getHairdresserClient(params);

      this.setState(
        { searchKey: '',
          selectedValue: _selected_staff,
          selectedOption: this.state.myData,
        },
        function () {
          self._getDataVal(self.state);
        }
      );
      self.exportCSV(0);
     this.getHairdresserClient(params);
    } else if (
      event.action === "deselect-option" &&
      event.option.value == "0"
    ) {
      this.setState({
        selectedStaffName: "",
      });
      this.setState(
        {
          searchKey: '',
          selectedValue: [],
          selectedOption: [],
        },
        function () {
          self._getDataVal(self.state);
        }
      );
    } else if (event.action === "deselect-option") {
      let selectedValue = [];
      this.setState({
        selectedStaffName: "",
        searchKey: '',
      });
      value.map((obj) => {
        if (obj.value != "0") {
          selectedValue.push(obj.value);
        }
      });
      this.setState(
        {
          searchKey: '',
          selectedValue,
          selectedOption: value.filter((o) => o.value !== "0"),
        },
        function () {
          self._getDataVal(self.state);
          self.exportCSV(0);
        }
      );
    } else if (value.length === this.state.myData.length - 1) {
      let _selected_staff = this.state.myData?.map((_selected) => {
        return _selected.value;
      });

      _selected_staff.splice(0, 1);
     // params.empIds = _selected_staff;
     // console.log("check the data here", params);
     // this.getHairdresserClient(params);
      
      this.setState(
        {
          searchKey: '',
          selectedValue: _selected_staff,
          selectedOption: this.state.myData,
        },
        function () {
          self._getDataVal(self.state);
          self.exportCSV(0);
        }
      );
    } else {
      let selectedValue = [];
      value.map((obj) => {
        //if(obj.value!="0"){
        selectedValue.push(obj.value);
        // }
      });
      //   params.empIds = _selected_staff;
      if (value?.length === 1) {
       // params.empIds = [value[0].value];
       // this.getHairdresserClient(params);
        this.getHairdresserClient(params);
        this.setState({
          searchKey: '',
          selectedStaffName: value[0].label,
        });
      } else {
        let empIds = value?.map((_selected_value) => {
          return _selected_value?.value;
        });
        params.hairdresserId = hairdresserId;
        this.getHairdresserClient(params);
        this.setState({
          searchKey: '',
          selectedStaffName: "",
        });
      }

      this.setState(
        {
          searchKey: '',
          selectedValue,
          selectedOption: value,
        },
        function () {
          self._getDataVal(self.state);
          self.exportCSV(0);
        }
      );
    }
  };

  handleSelectOpen = () => {
    document.body.classList.add('dairy-filter-menu_open')
    this.setState({
      isSelectopen: true,
    });
  };

  handleSelectClose = () => {
    document.body.classList.remove('dairy-filter-menu_open');
    this.setState({
      isSelectopen: false,
    });
  };

  toggleConsentMode = () => {
    this.setState((prev) => ({
      consentMode: !prev.consentMode,
      mergeMode: false,
      selectedClients: [],
      consentConfirmed: false,
      consentAllSelected: false,
    }));
  };

  // Sweeps the WHOLE client base matching the current search and filters,
  // page by page, via the service directly (dispatching the list action here
  // would clobber the visible table through the redux reducer)
  selectAllLoadedClients = async () => {
    if (this.state.consentSelectingAll) return;
    if (this.state.consentAllSelected && this.state.selectedClients.length) {
      this.setState({ selectedClients: [], consentAllSelected: false });
      return;
    }
    this.setState({ consentSelectingAll: true });
    const { filters, sortField, sortOrder, searchKey } = this.state;
    const empIds = filters.teamMembers && filters.teamMembers.length > 0
      ? filters.teamMembers.map((tm) => tm.value)
      : '';
    const ids = [];
    const limit = 200;
    try {
      for (let page = 1; page <= 25; page += 1) {
        // eslint-disable-next-line no-await-in-loop
        const res = await hairdresserService.getClientsPaginated({
          searchKey: searchKey || filters.searchQuery || '',
          page,
          limit,
          isDownload: 0,
          empIds,
          startDate: filters.startDate || '',
          endDate: filters.endDate || '',
          minSales: filters.minSales,
          maxSales: filters.maxSales,
          sortField: sortField || 'name',
          sortOrder: sortOrder || 'asc',
        });
        const data = res?.data?.responseData || res?.data?.data || {};
        const batch = (data.clients || []).map((c) => c.userId || c._id).filter(Boolean);
        ids.push(...batch);
        if (batch.length < limit) break;
      }
      this.setState({
        selectedClients: Array.from(new Set(ids)),
        consentAllSelected: true,
        consentSelectingAll: false,
      });
    } catch (e) {
      this.setState({ consentSelectingAll: false });
      toast.error('Could not load the full client list. Please try again.');
    }
  };

  applyBulkConsent = async () => {
    const { selectedClients, consentEmail, consentSms, consentValue } = this.state;
    if (!selectedClients.length || (!consentEmail && !consentSms)) return;
    const fields = {};
    if (consentEmail) fields.emailMarketingConsent = consentValue;
    if (consentSms) fields.smsMarketingConsent = consentValue;
    const hairdresserId = localStorage.getItem('userId');
    this.setState({ consentApplying: true, consentProgress: 0 });
    const chunkSize = 5;
    let done = 0;
    for (let i = 0; i < selectedClients.length; i += chunkSize) {
      const batch = selectedClients.slice(i, i + chunkSize);
      // eslint-disable-next-line no-await-in-loop
      await Promise.all(batch.map((id) =>
        this.props.dispatch(hairdresserActions.editClient({ hairdresserId, userId: id, ...fields })).catch(() => {})
      ));
      done += batch.length;
      this.setState({ consentProgress: done });
    }
    const count = selectedClients.length;
    this.setState({
      consentApplying: false,
      consentModalOpen: false,
      consentMode: false,
      selectedClients: [],
      consentConfirmed: false,
    });
    toast.success(`Marketing permissions updated for ${count} client${count !== 1 ? 's' : ''}`);
  };

  // Merge Mode Methods
  toggleMergeMode = () => {
    this.setState(prevState => ({
      mergeMode: !prevState.mergeMode,
      consentMode: false,
      selectedClients: [],
      mergeCheck: null
    }));
  };

  // Refusals no swap of the kept record can fix. "Keep the login record" is
  // left to the panel, which swaps the two by itself.
  static HARD_REFUSALS = ['no_permission', 'private_client', 'co_held_private', 'staff_account', 'both_have_login', 'separate_records', 'paused'];

  // Ask the server about the two picked as soon as both are ticked, so a
  // pair that can't be merged says so here instead of after "Merge selected".
  checkMergePair = () => {
    const ids = this.state.selectedClients;
    if (!this.state.mergeMode || ids.length !== 2) { if (this.state.mergeCheck) this.setState({ mergeCheck: null }); return; }
    const pairKey = ids.slice().sort().join(':');
    if (this.state.mergeCheck && this.state.mergeCheck.pairKey === pairKey) return;
    this.setState({ mergeCheck: { pairKey, code: null, pending: true } });
    const verdict = (code) => {
      if (this.state.selectedClients.slice().sort().join(':') !== pairKey) return;
      let c = Clients.HARD_REFUSALS.includes(code) ? code : null;
      // A stylist who can't merge salon clients can still merge their own.
      if (c === 'no_permission' && isSelfEmployedMe() && !can('clients_all')) c = 'own_book_only';
      this.setState({ mergeCheck: { pairKey, code: c, pending: false } });
    };
    clientSyncService.previewMerge({ winnerUserId: ids[0], loserUserId: ids[1] })
      .then((res) => {
        const d = res && res.data;
        if (d && d.statusCode === 0) return verdict(d.error && d.error.code);
        const safety = d && (d.responseData || d.data) && (d.responseData || d.data).safety;
        verdict(safety && safety.allowed === false ? safety.code : null);
      })
      // Unknown: let the panel make the call, as before.
      .catch(() => verdict(null));
  };

  mergeHint() {
    const n = this.state.selectedClients.length;
    const check = this.state.mergeCheck;
    if (n === 2 && check && check.code) return refusalCopy(check.code).title;
    if (n) return `${n} of 2 clients selected`;
    return isSelfEmployedMe() && !can('clients_all') ? 'Select two of your own clients to merge' : 'Select the two duplicate clients to merge';
  }

  mergeBlocked() {
    const check = this.state.mergeCheck;
    return this.state.selectedClients.length !== 2 || !!(check && (check.pending || check.code));
  }

  handleClientSelect = (clientId, event) => {
    event.stopPropagation();
    this.setState(prevState => {
      const isSelected = prevState.selectedClients.includes(clientId);
      // Merge is pairwise (safety matrix + rollback are per-pair): once two
      // are picked in merge mode, further clicks are ignored until one is
      // deselected. Consent mode keeps unlimited selection.
      if (!isSelected && prevState.mergeMode && prevState.selectedClients.length >= 2) {
        return null;
      }
      return {
        selectedClients: isSelected
          ? prevState.selectedClients.filter(id => id !== clientId)
          : [...prevState.selectedClients, clientId]
      };
    }, () => { if (this.state.mergeMode) this.checkMergePair(); });
  };

  startMergeFlow = () => {
    const { selectedClients } = this.state;
    if (selectedClients.length !== 2 || this.mergeBlocked()) return;
    // Canonical merge (userMerge module: server-side safety matrix,
    // transactional confirm, 72h rollback) in the slide panel. First
    // selected defaults to the surviving record; the panel has a swap.
    this.setState({
      mergePanelOpen: true,
      mergePanelWinnerId: selectedClients[0],
      mergePanelLoserId: selectedClients[1],
    });
  };

  componentDidUpdate(prevProps) {
    // Deep-link: keep the detail panel in sync with /clients/:id (e.g. global
    // search navigates here, or back/forward). Opens the panel for the URL's
    // client, closes it when the id is dropped.
    const urlClientId = this.props.match?.params?.id || null;
    const prevUrlClientId = prevProps.match?.params?.id || null;
    if (urlClientId !== prevUrlClientId && urlClientId !== this.state.clientDetailPanelId) {
      this.setState({ clientDetailPanelId: urlClientId });
    }

    const _hairdresser = this.props.hairdresserClient;
    if (_hairdresser !== prevProps.hairdresserClient) {
      if(_hairdresser.client != undefined){
        const newClients = _hairdresser?.client || [];
        const newPagination = _hairdresser?.pagination;

        // Append vs replace is decided by the RESPONSE's own page number, not
        // the mutable isLoadingMore flag. That flag races with scroll-triggered
        // loads: if it flipped false before a page-2+ response landed, the old
        // code REPLACED the whole list with that single page — so mid-alphabet
        // pages silently vanished (list jumped A→B then N→Z). Page 1 (or
        // unknown) = fresh load → replace; any later page → append, deduped by
        // _id so an out-of-order or repeated page can't drop or duplicate rows.
        const responsePage = newPagination?.page || 1;
        let mergedClients;
        if (responsePage > 1) {
          const seen = new Set((this.state.hairdresserClient || []).map(c => String(c._id)));
          const fresh = newClients.filter(c => !seen.has(String(c._id)));
          mergedClients = [...(this.state.hairdresserClient || []), ...fresh];
        } else {
          mergedClients = newClients;
        }

        this.setState({
          hairdresserClient: mergedClients,
          pagination: newPagination,
          hasMore: newPagination?.hasMore || false
        });
      } else {
        this.setState({
          hairdresserClient: [],
          hasMore: false
        });
      }
    }
  }

  handleClickOutsideFilter = (event) => {
    let self = this;
    if (this.filterRef.current && !this.filterRef.current.contains(event.target)) {
      self.setState({
        openDragFilterPopup :false,
        isSelectopen:false
     })
     if(!this.state.openDragFilterPopup){
        document.body.classList.remove('dairy-filter-menu_open');
     }
     self.props.dispatch(hairdresserActions.getHairdresserScheduleReset());
     if(self.state.selectedHairdressers?.length>0){
        self.props.dispatch(hairdresserActions.dairyFilterData(self.state.selectedHairdressers));
        self.createCalendarSlots(self.state.selectedHairdressers);
     }else{
        self.props.dispatch(hairdresserActions.dairyFilterData(self.state.staffList));
        self.createCalendarSlots(self.state.staffList);
     }
    }
  };

  
  render() {
    const isMobileView = this.state.viewportWidth <= 768;
    const { filters } = this.state;
    const activeFilterCount =
      (filters?.teamMembers?.length || 0) +
      ((filters?.startDate || filters?.endDate) ? 1 : 0) +
      ((filters?.minSales !== null && filters?.minSales !== undefined) || (filters?.maxSales !== null && filters?.maxSales !== undefined) ? 1 : 0);
    const selectionModeActive = this.state.mergeMode || this.state.consentMode;
    return (
      <>
      <div className="h_n catalogue-no-header">
        <div className="body_container cm_bg_white">
          <TopHeader title="Clients" headerButtonStatus={false} {...this.props} />
          <div className="catalogue-page-wrapper">
            <ClientsTopNav activeTab="clientList" onTabChange={(tab) => {
              if (tab === 'dataSharing') this.props.history.push('/clients/data-sharing');
            }}>
              {this.checkReadOnly() && (
                <>
                  {this.canExportClients() && (
                  <button
                    onClick={() => this.exportCSV(1)}
                    className="catalogue-add-btn clients-export-btn"
                  >
                    Export
                  </button>
                  )}
                  <Dropdown className="catalogue-add-dropdown">
                    <Dropdown.Toggle id="catalogue-add-clients"><span>Add</span></Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item onClick={() => this.setState({ showAddClientPanel: true })}>New client</Dropdown.Item>
                      {ONBOARDING_ENABLED && canImport() && <Dropdown.Item onClick={() => openOnboardingLayer({ mode: 'import' })}>Import from a file</Dropdown.Item>}
                    </Dropdown.Menu>
                  </Dropdown>
                </>
              )}
            </ClientsTopNav>
            <div className="catalogue-content-container">
              <div className={`clients-table-container${selectionModeActive && isMobileView ? ' clients-page-selection-active' : ''}`}>
                <div className="clients-toolbar">
                  <div className="staff-search clients-toolbar-search">
                    <svg className="staff-search-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/>
                    </svg>
                    <input
                      type="text"
                      className="staff-search-input"
                      name="clientSearch"
                      value={this.state.searchKey}
                      onChange={this.handleSearchChange}
                      placeholder="Search clients..."
                    />
                    {this.state.searchCrossIcon && (
                      <button className="staff-search-clear" onClick={this.handleResetSearchChange} type="button">
                        <RxCross2 />
                      </button>
                    )}
                  </div>
                  <div className="clients-toolbar-actions">
                    {this.state.duplicatesAvailable && typeof this.state.salonMergeEnabled === 'boolean' && (
                      <button
                        onClick={() => this.setState({ duplicatesReviewOpen: true })}
                        title="Check for clients who are on here more than once"
                        className="clients-tool-btn clients-tool-btn--dupes"
                      >
                        <svg width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="7"/><path d="m21 21-4.3-4.3"/><path d="M8.5 11h5"/></svg>
                        <span>Find duplicates</span>
                      </button>
                    )}
                    {this.canMergeClients() && <button
                      onClick={this.toggleMergeMode}
                      title="Select two duplicate clients and merge them into one record"
                      className={`clients-tool-btn clients-tool-btn--merge${this.state.mergeMode ? ' is-active' : ''}`}
                    >
                      <svg width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 21a8 8 0 0 0-16 0"/><circle cx="10" cy="8" r="5"/><path d="M22 20c0-3.37-2-6.5-4-8a5 5 0 0 0-.45-8.3"/></svg>
                      <span>{this.state.mergeMode ? 'Exit merge' : 'Merge'}</span>
                    </button>}
                    <button
                      onClick={this.toggleConsentMode}
                      title="Bulk update email and SMS marketing permissions"
                      className={`clients-tool-btn clients-tool-btn--consent${this.state.consentMode ? ' is-active' : ''}`}
                    >
                      <svg width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>
                      <span>{this.state.consentMode ? 'Exit permissions' : 'Permissions'}</span>
                    </button>
                    <button
                      onClick={this.filterClick}
                      className={`clients-tool-btn clients-tool-btn--filters${this.state.filterPopup ? ' is-active' : ''}`}
                    >
                      <svg width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" />
                      </svg>
                      <span>Filters</span>
                      {activeFilterCount > 0 && (
                        <span className="clients-filter-badge">{activeFilterCount}</span>
                      )}
                    </button>
                    <button
                      type="button"
                      aria-label="More options"
                      className="clients-tool-btn clients-tool-btn--more"
                      onClick={() => this.setState({ showMoreSheet: true })}
                    >
                      <svg width="18" height="18" fill="currentColor" viewBox="0 0 24 24"><circle cx="5" cy="12" r="2"/><circle cx="12" cy="12" r="2"/><circle cx="19" cy="12" r="2"/></svg>
                    </button>
                    {this.state.filterPopup && (
                      <ClientFiltersPopup
                        filters={this.state.filters}
                        onSend={this.handleApplyFilters}
                        onClose={this.handleClose}
                        isMobile={isMobileView}
                        isSalonOwner={this.state.isSalonOwner === 1}
                      />
                    )}
                  </div>
                </div>
                    

                    {/* Merge Mode Banner - Full Width Row (desktop) */}
                    {this.state.mergeMode && !isMobileView && (
                      <div className="merge-mode-banner mt-3 px-4 py-3" style={{
                        background: 'linear-gradient(135deg, #FFF9E6 0%, #FFF3CD 100%)',
                        border: '1px solid #FFD966',
                        borderRadius: '8px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        boxShadow: '0 2px 8px rgba(255, 193, 7, 0.15)'
                      }}>
                        <div className="d-flex align-items-center" style={{ gap: '12px' }}>
                          <span style={{
                            fontSize: '20px',
                            lineHeight: '1'
                          }}>⚠️</span>
                          <span style={{
                            color: '#856404',
                            fontWeight: '600',
                            fontSize: '15px',
                            letterSpacing: '-0.01em'
                          }}>
                            {this.mergeHint()}
                          </span>
                        </div>
                        <div className="d-flex align-items-center" style={{ gap: '12px' }}>
                          <button
                            onClick={this.toggleMergeMode}
                            className="btn"
                            style={{
                              backgroundColor: 'transparent',
                              color: '#29282D',
                              border: '1px solid #29282D',
                              borderRadius: '6px',
                              padding: '8px 20px',
                              fontWeight: '500',
                              fontSize: '14px',
                              transition: 'all 0.2s ease'
                            }}
                            onMouseOver={(e) => {
                              e.target.style.backgroundColor = '#29282D';
                              e.target.style.color = 'white';
                            }}
                            onMouseOut={(e) => {
                              e.target.style.backgroundColor = 'transparent';
                              e.target.style.color = '#29282D';
                            }}
                          >
                            Cancel
                          </button>
                          <button
                            onClick={this.startMergeFlow}
                            className="btn"
                            disabled={this.mergeBlocked()}
                            style={{
                              backgroundColor: this.mergeBlocked() ? '#CCCCCC' : '#29282D',
                              color: 'white',
                              border: 'none',
                              borderRadius: '6px',
                              padding: '8px 24px',
                              fontWeight: '600',
                              fontSize: '14px',
                              transition: 'all 0.2s ease',
                              cursor: this.mergeBlocked() ? 'not-allowed' : 'pointer'
                            }}
                            onMouseOver={(e) => {
                              if (!this.mergeBlocked()) {
                                e.target.style.backgroundColor = '#1a1a1a';
                              }
                            }}
                            onMouseOut={(e) => {
                              if (!this.mergeBlocked()) {
                                e.target.style.backgroundColor = '#29282D';
                              }
                            }}
                          >
                            Merge selected ({this.state.selectedClients.length}/2)
                          </button>
                        </div>
                      </div>
                    )}

                    {/* Marketing permissions banner (desktop) */}
                    {this.state.consentMode && !isMobileView && (
                      <div className="mt-3 px-4 py-3" style={{
                        background: 'rgba(0,126,160,0.06)',
                        border: '1px solid rgba(0,126,160,0.25)',
                        borderRadius: '12px',
                        display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap'
                      }}>
                        <span style={{ fontSize: '13.5px', fontWeight: 600, color: '#007EA0', flex: 1, minWidth: '200px' }}>
                          {this.state.selectedClients.length
                            ? `${this.state.selectedClients.length} client${this.state.selectedClients.length !== 1 ? 's' : ''} selected`
                            : 'Select clients to update their marketing permissions'}
                        </span>
                        <button
                          type="button"
                          onClick={this.selectAllLoadedClients}
                          style={{ padding: '8px 14px', borderRadius: '100px', border: '1px solid rgba(0,126,160,0.4)', background: '#fff', fontSize: '12.5px', fontWeight: 600, color: '#007EA0', cursor: 'pointer' }}
                        >
                          {this.state.consentSelectingAll
                            ? 'Selecting all clients...'
                            : this.state.consentAllSelected && this.state.selectedClients.length
                              ? 'Deselect all'
                              : 'Select all clients'}
                        </button>
                        <button
                          type="button"
                          disabled={!this.state.selectedClients.length}
                          onClick={() => this.setState({ consentModalOpen: true, consentConfirmed: false })}
                          style={{
                            padding: '8px 18px', borderRadius: '100px', border: 'none',
                            background: this.state.selectedClients.length ? '#29282D' : '#C7C7CC',
                            fontSize: '12.5px', fontWeight: 600, color: '#fff',
                            cursor: this.state.selectedClients.length ? 'pointer' : 'default'
                          }}
                        >
                          Set permissions ({this.state.selectedClients.length})
                        </button>
                      </div>
                    )}

                    {/* Mobile selection hints (fixed action bars render at page end) */}
                    {this.state.mergeMode && isMobileView && (
                      <div className="clients-selection-hint clients-selection-hint--merge">
                        {this.mergeHint()}
                      </div>
                    )}
                    {this.state.consentMode && isMobileView && (
                      <div className="clients-selection-hint clients-selection-hint--consent">
                        {this.state.selectedClients.length
                          ? `${this.state.selectedClients.length} client${this.state.selectedClients.length !== 1 ? 's' : ''} selected`
                          : 'Select clients to update their marketing permissions'}
                      </div>
                    )}

                    {(this.state.filters?.teamMembers?.length > 0 || this.state.filters?.startDate || this.state.filters?.endDate || this.state.filters?.minSales || this.state.filters?.maxSales) && (
                      <div className="applied_filter_container">
                        {this.state.filters.teamMembers && this.state.filters.teamMembers.length > 0 &&
                          this.state.filters.teamMembers.map((member, index) => (
                            <span key={index}>
                              {member.label}
                              <i className="_cross" onClick={() => {
                                const updatedMembers = this.state.filters.teamMembers.filter((_, i) => i !== index);
                                this.setState(prevState => ({
                                  filters: {
                                    ...prevState.filters,
                                    teamMembers: updatedMembers,
                                    teamMemberNames: updatedMembers.length > 0 ? updatedMembers.map(tm => tm.label).join(', ') : null
                                  }
                                }), () => {
                                  this.applyFiltersToData();
                                });
                              }}>
                                <RxCross2 />
                              </i>
                            </span>
                          ))
                        }
                        {this.state.filters.startDate && (
                          <span>
                            Last Booked From: {new Date(this.state.filters.startDate).toLocaleDateString('en-GB')}
                            <i className="_cross" onClick={() => this.handleResetFilters('startDate')}>
                              <RxCross2 />
                            </i>
                          </span>
                        )}
                        {this.state.filters.endDate && (
                          <span>
                            Last Booked To: {new Date(this.state.filters.endDate).toLocaleDateString('en-GB')}
                            <i className="_cross" onClick={() => this.handleResetFilters('endDate')}>
                              <RxCross2 />
                            </i>
                          </span>
                        )}
                        {this.state.filters.minSales !== null && this.state.filters.minSales !== undefined && (
                          <span>
                            Sales ≥ £{this.state.filters.minSales.toFixed(2)}
                            <i className="_cross" onClick={() => this.handleResetFilters('minSales')}>
                              <RxCross2 />
                            </i>
                          </span>
                        )}
                        {this.state.filters.maxSales !== null && this.state.filters.maxSales !== undefined && (
                          <span>
                            Sales ≤ £{this.state.filters.maxSales.toFixed(2)}
                            <i className="_cross" onClick={() => this.handleResetFilters('maxSales')}>
                              <RxCross2 />
                            </i>
                          </span>
                        )}
                      </div>
                    )}

            <div className="clients-list-card" style={{ position: 'relative' }}>
              <table className={`clients-table ${(this.state.mergeMode || this.state.consentMode) ? 'merge-mode-active' : ''}`}>
                <thead>
                <tr>
                  {(this.state.mergeMode || this.state.consentMode) && (
                    <th style={{ width: '3%' }}></th>
                  )}
                  <th style={{ width: '45%' }}>
                    Client Name
                  </th>
                  <th style={{ width: '20%' }}>
                    Number
                  </th>
                  <th style={{ width: '20%' }}>
                    Last Booked
                  </th>
                  <th style={{ width: '15%' }}>
                    Sales
                  </th>
                </tr>
              </thead>
              <tbody>
                {this.state.isLoading ? (
                  // Skeleton loader rows
                  [...Array(20)].map((_, i) => (
                    <tr key={`skeleton-${i}`} className="skeleton-row">
                      {(this.state.mergeMode || this.state.consentMode) && <td></td>}
                      <td>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
                          <div className="skeleton-avatar" style={{ width: '36px', height: '36px' }}></div>
                          <div style={{ flex: 1 }}>
                            <div className="skeleton-text skeleton-name"></div>
                            <div className="skeleton-text skeleton-email"></div>
                          </div>
                        </div>
                      </td>
                      <td><div className="skeleton-text skeleton-phone"></div></td>
                      <td><div className="skeleton-text skeleton-date"></div></td>
                      <td><div className="skeleton-text skeleton-sales"></div></td>
                    </tr>
                  ))
                ) : this.state.hairdresserClient ? (
                  this.state.hairdresserClient.length > 0 ? (
                    this.state.hairdresserClient.map((client, i) =>
                      client.name !== "Unknown" ? (
                        <tr
                          key={client._id}
                          onClick={(this.state.mergeMode || this.state.consentMode)
                            ? () => this.handleClientSelect(client.userId || client._id, { stopPropagation: () => {} })
                            : this.selectClient.bind(this, client._id, null)
                          }
                          onContextMenu={(e) => !(this.state.mergeMode || this.state.consentMode) && this.handleClientContextMenu(e, client)}
                          className={`clients-table-row ${(this.state.mergeMode || this.state.consentMode) && this.state.selectedClients.includes(client.userId || client._id) ? 'selected' : ''}`}
                          style={{ cursor: 'pointer' }}
                        >
                            {(this.state.mergeMode || this.state.consentMode) && (
                              <td className="checkbox-cell" onClick={(e) => e.stopPropagation()}>
                                <input
                                  type="checkbox"
                                  checked={this.state.selectedClients.includes(client.userId || client._id)}
                                  onChange={(e) => this.handleClientSelect(client.userId || client._id, e)}
                                  onClick={(e) => e.stopPropagation()}
                                />
                              </td>
                            )}
                            <td>
                              <div style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
                                {client.localAvatar ? (
                                  <div className="client-row-avatar">
                                    <img
                                      alt=""
                                      src={client.localAvatar}
                                    />
                                  </div>
                                ) : (
                                  <div className="client-row-avatar client-row-avatar--initials">
                                    {client.name?.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2) || 'C'}
                                  </div>
                                )}
                                <div style={{ flex: 1, minWidth: 0 }}>
                                  <div className="client-row-name">{client.name}</div>
                                  <div className={`client-row-email${!this.checkEmail(client.email) ? ' client-row-email--empty' : ''}`}>
                                    {this.checkEmail(client.email) ? client.email : "--"}
                                  </div>
                                </div>
                                {client.lastBookingDate && (
                                  <div className="client-row-meta">
                                    {new Date(client.lastBookingDate).toLocaleDateString('en-GB')}
                                  </div>
                                )}
                              </div>
                            </td>
                            <td>
                              {client.phoneNumber ? client.phoneNumber : "--"}
                            </td>
                            <td>{client?.lastBookingDate ? new Date(client.lastBookingDate).toLocaleDateString('en-GB') : '--'}</td>
                            <td>£{client?.totalSales ? client.totalSales.toFixed(2) : '0.00'}</td>
                          </tr>
                        ) : (
                          ""
                        )
                      )
                    ) : (
                      <tr>
                        <td colSpan={(this.state.mergeMode || this.state.consentMode) ? 5 : 4} className="text-center" style={{ padding: '40px 20px' }}>
                          No Client available
                        </td>
                      </tr>
                    )
                  ) : (
                    null
                  )}
                  {this.state.isLoadingMore && (
                    [...Array(5)].map((_, i) => (
                      <tr key={`skeleton-more-${i}`} className="skeleton-row">
                        {(this.state.mergeMode || this.state.consentMode) && <td></td>}
                        <td>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
                            <div className="skeleton-avatar" style={{ width: '36px', height: '36px' }}></div>
                            <div style={{ flex: 1 }}>
                              <div className="skeleton-text skeleton-name"></div>
                              <div className="skeleton-text skeleton-email"></div>
                            </div>
                          </div>
                        </td>
                        <td><div className="skeleton-text skeleton-phone"></div></td>
                        <td><div className="skeleton-text skeleton-date"></div></td>
                        <td><div className="skeleton-text skeleton-sales"></div></td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
              {this.state.otherSiteClients && this.state.otherSiteClients.length > 0 && (
                <div className="ml-other-site-clients">
                  <div className="ml-other-site-title">At your other locations</div>
                  {this.state.otherSiteClients.map((c, idx) => (
                    <div
                      key={`${c.userId || idx}:${c.salonId || ''}`}
                      className="ml-other-site-row ml-other-site-row--open"
                      role="button"
                      tabIndex={0}
                      title={`Open ${c.name || 'client'}`}
                      onClick={() => c.userId && this.selectClient(String(c.userId))}
                      onKeyDown={(e) => { if ((e.key === 'Enter' || e.key === ' ') && c.userId) { e.preventDefault(); this.selectClient(String(c.userId)); } }}
                    >
                      <span className="ml-other-site-name">{c.name}</span>
                      <span className="ml-other-site-site"><span className="ml-dot" style={{ background: siteColour(c.salonId) }} />{c.salonName}</span>
                      <span className="ml-other-site-contact">{c.phoneNumber || (c.email && !String(c.email).includes('@beuapp.com') ? c.email : '')}</span>
                      <button
                        type="button"
                        className="ml-other-site-book"
                        onClick={(e) => { e.stopPropagation(); if (c.userId) this.selectClient(String(c.userId), 'book'); }}
                      >Book</button>
                    </div>
                  ))}
                </div>
              )}
            </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      {/* Mobile fixed action bars for merge / permissions selection modes */}
      {this.state.mergeMode && isMobileView && (
        <div className="clients-selection-bar">
          <button type="button" className="csb-cancel" onClick={this.toggleMergeMode}>Cancel</button>
          <button
            type="button"
            className="csb-primary"
            disabled={this.mergeBlocked()}
            onClick={this.startMergeFlow}
          >
            Merge selected ({this.state.selectedClients.length}/2)
          </button>
        </div>
      )}
      {this.state.consentMode && isMobileView && (
        <div className="clients-selection-bar">
          <button type="button" className="csb-cancel" onClick={this.toggleConsentMode}>Cancel</button>
          <button type="button" className="csb-secondary" onClick={this.selectAllLoadedClients}>
            {this.state.consentSelectingAll
              ? 'Selecting...'
              : this.state.consentAllSelected && this.state.selectedClients.length
                ? 'Deselect all'
                : 'Select all'}
          </button>
          <button
            type="button"
            className="csb-primary"
            disabled={!this.state.selectedClients.length}
            onClick={() => this.setState({ consentModalOpen: true, consentConfirmed: false })}
          >
            Set permissions ({this.state.selectedClients.length})
          </button>
        </div>
      )}

      {/* Mobile "More" sheet: secondary bulk actions live here on small screens */}
      {this.state.showMoreSheet && (
        <SlidePanel
          title="Manage clients"
          compact
          onClose={() => this.setState({ showMoreSheet: false })}
        >
          <div className="clients-more-list">
            {this.canMergeClients() && <button
              type="button"
              className="clients-more-item"
              onClick={() => this.setState({ showMoreSheet: false }, this.toggleMergeMode)}
            >
              <svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M18 21a8 8 0 0 0-16 0"/><circle cx="10" cy="8" r="5"/><path d="M22 20c0-3.37-2-6.5-4-8a5 5 0 0 0-.45-8.3"/></svg>
              <span>Merge clients<small>Combine two duplicate records into one</small></span>
            </button>}
            <button
              type="button"
              className="clients-more-item"
              onClick={() => this.setState({ showMoreSheet: false }, this.toggleConsentMode)}
            >
              <svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>
              <span>Set marketing permissions<small>Bulk update email and SMS consent</small></span>
            </button>
            {this.canExportClients() && (
              <button
                type="button"
                className="clients-more-item"
                onClick={() => this.setState({ showMoreSheet: false }, () => this.exportCSV(1))}
              >
                <svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
                <span>Export CSV<small>Download the full client list</small></span>
              </button>
            )}
          </div>
        </SlidePanel>
      )}

      {/* Merge sidebar — canonical userMerge flow from the multi-select */}
      {this.state.duplicatesReviewOpen && (
        <DuplicatesReviewPanel
          initial={null}
          mergeOff={this.state.salonMergeEnabled !== true}
          onClose={() => this.setState({ duplicatesReviewOpen: false })}
          onMerged={this.handleDuplicatesMerged}
        />
      )}
      {this.state.mergeResult && (
        <MergeResultToast
          key={this.state.mergeResult.key}
          batchIds={this.state.mergeResult.batchIds}
          results={this.state.mergeResult.results}
          mergeId={this.state.mergeResult.mergeId}
          onClose={() => this.setState({ mergeResult: null })}
          onUndone={() => { this.applyFiltersToData(); this.loadDuplicates(); }}
        />
      )}
      {this.state.mergePanelOpen && (
        <MergeClientsPanel
          initialWinnerUserId={this.state.mergePanelWinnerId}
          initialLoserUserId={this.state.mergePanelLoserId}
          onClose={() => this.setState({ mergePanelOpen: false })}
          onConfirmed={(data) => {
            this.setState({
              mergePanelOpen: false, mergeMode: false, selectedClients: [], mergeCheck: null,
              // Say it worked, with Undo, rather than the client just vanishing.
              mergeResult: data && data.mergeId ? { mergeId: data.mergeId, key: Date.now() } : this.state.mergeResult,
            });
            this.applyFiltersToData();
            this.loadDuplicates();
          }}
        />
      )}

      {/* Client Detail Panel */}
      {this.state.clientDetailPanelId && (
        <ClientDetailPanel
          key={this.state.clientDetailPanelId + (this.state.clientDetailAction || '')}
          clientId={this.state.clientDetailPanelId}
          initialAction={this.state.clientDetailAction}
          // /clients/:id?tab=messages (the bell's "texted you") opens on that tab.
          initialTab={this.props.match?.params?.id === this.state.clientDetailPanelId ? (new URLSearchParams(this.props.location?.search || '').get('tab') || undefined) : undefined}
          onClose={this.handleClientPanelClose}
          onClientUpdated={this.handleClientUpdated}
          history={this.props.history}
          user={this.props.user}
        />
      )}

      {this.state.contextMenu && (
        <ListContextMenu
          x={this.state.contextMenu.x}
          y={this.state.contextMenu.y}
          items={[
            {
              label: 'View Client',
              icon: <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><circle cx="8" cy="5" r="3" stroke="currentColor" strokeWidth="1.2"/><path d="M2 14c0-3.3 2.7-6 6-6s6 2.7 6 6" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"/></svg>,
              action: 'view'
            },
            ...(this.canDeleteFromList() ? [{ divider: true },
            {
              label: 'Delete Client',
              icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6" /><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" /></svg>,
              action: 'delete',
              danger: true
            }] : [])
          ]}
          onAction={this.handleContextMenuAction}
          onClose={() => this.setState({ contextMenu: null })}
        />
      )}

      {/* Add Client Panel */}
      {this.state.showAddClientPanel && (
        <AddClientPanel
          onClose={() => this.setState({ showAddClientPanel: false })}
          onClientAdded={() => {
            this.setState({ showAddClientPanel: false });
            this.getHairdresserClient({
              searchKey: '',
              hairdresserId: localStorage.getItem('userId'),
              page: 1,
              listType: 1,
              isDownload: 0,
            });
          }}
          history={this.props.history}
        />
      )}

      {this.state.consentModalOpen && (
        <SlidePanel
          title="Marketing permissions"
          width={440}
          zIndex={100020}
          onClose={() => !this.state.consentApplying && this.setState({ consentModalOpen: false })}
          footer={(
            <>
              <button
                type="button"
                className="sp-btn-secondary"
                disabled={this.state.consentApplying}
                onClick={() => this.setState({ consentModalOpen: false })}
              >
                Cancel
              </button>
              <button
                type="button"
                className="sp-btn-primary"
                disabled={this.state.consentApplying || (!this.state.consentEmail && !this.state.consentSms) || (this.state.consentValue && !this.state.consentConfirmed)}
                onClick={this.applyBulkConsent}
                style={(this.state.consentApplying || (!this.state.consentEmail && !this.state.consentSms) || (this.state.consentValue && !this.state.consentConfirmed)) ? { background: '#C7C7CC', cursor: 'default' } : undefined}
              >
                {this.state.consentApplying
                  ? `Updating ${this.state.consentProgress} of ${this.state.selectedClients.length}...`
                  : this.state.consentValue ? `Opt in ${this.state.selectedClients.length} clients` : `Opt out ${this.state.selectedClients.length} clients`}
              </button>
            </>
          )}
        >
          <div>
            <p style={{ fontSize: '13.5px', color: '#8E8E93', margin: '0 0 18px' }}>
              Applies to {this.state.selectedClients.length} selected client{this.state.selectedClients.length !== 1 ? 's' : ''}. They can change their mind at any time.
            </p>

            <div style={{ display: 'flex', gap: '8px', marginBottom: '18px' }}>
              {[{ v: true, label: 'Opt in' }, { v: false, label: 'Opt out' }].map(opt => (
                <button
                  key={String(opt.v)}
                  type="button"
                  onClick={() => this.setState({ consentValue: opt.v })}
                  style={{
                    flex: 1, padding: '11px', borderRadius: '10px', fontSize: '13.5px', fontWeight: 600,
                    border: this.state.consentValue === opt.v ? '2px solid #29282D' : '1px solid #ECECF0',
                    background: this.state.consentValue === opt.v ? '#29282D' : '#fff',
                    color: this.state.consentValue === opt.v ? '#fff' : '#4B4B52', cursor: 'pointer', fontFamily: 'inherit'
                  }}
                >
                  {opt.label}
                </button>
              ))}
            </div>

            {[{ key: 'consentEmail', label: 'Email marketing' }, { key: 'consentSms', label: 'SMS marketing' }].map(ch => (
              <label key={ch.key} style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '11px 0', borderBottom: '1px solid #F2F2F7', cursor: 'pointer' }}>
                <input
                  type="checkbox"
                  checked={this.state[ch.key]}
                  onChange={(e) => this.setState({ [ch.key]: e.target.checked })}
                  style={{ width: '17px', height: '17px', accentColor: '#29282D' }}
                />
                <span style={{ fontSize: '14px', fontWeight: 600, color: '#1A1A1E' }}>{ch.label}</span>
              </label>
            ))}

            {this.state.consentValue && (
              <label style={{ display: 'flex', alignItems: 'flex-start', gap: '10px', margin: '18px 0 0', padding: '12px 14px', background: 'rgba(160,90,31,0.06)', borderRadius: '10px', cursor: 'pointer' }}>
                <input
                  type="checkbox"
                  checked={this.state.consentConfirmed}
                  onChange={(e) => this.setState({ consentConfirmed: e.target.checked })}
                  style={{ width: '17px', height: '17px', marginTop: '1px', accentColor: '#29282D', flexShrink: 0 }}
                />
                <span style={{ fontSize: '12.5px', color: '#4B4B52', lineHeight: 1.55 }}>
                  I confirm these are existing clients who gave us their details and can opt out at any time (the soft opt-in), or who have given consent to marketing.
                </span>
              </label>
            )}
          </div>
        </SlidePanel>
      )}


    </>
    );
  }
}

function mapStateToProps(state) {
  return {
    ...state,
  };
}

export default connect(mapStateToProps)(Clients);
